export default "__VITE_ASSET__CNqzMuqZ__"